import { css } from '@emotion/core';
import { Dialog } from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import { ClassAttributes, createElement, SyntheticEvent } from 'react';

import mq from '../../styleUtility/mediaquery';

interface Props {
  onRequestClose: (e: SyntheticEvent<HTMLElement>) => void;
  className?: string;
}

const DialogWithPadding = ({
  children,
  className,
  onRequestClose,
  ...otherProps
}: ClassAttributes<HTMLElement> & DialogProps & Props) => (
  <Dialog onClose={onRequestClose} classes={{ paper: dialogStyle }} className={className} {...otherProps}>
    {children}
  </Dialog>
);

const dialogStyle = css({
  maxWidth: 'calc(100% - 180px)',
  [mq('sp')]: {
    maxWidth: 600,
  },
}).toString();

export default DialogWithPadding;
